"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelFieldNestedList = exports.FormModelMutatorNestedList = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var form_field_1 = require("../form.field");
var form_nested_list_builder_1 = require("./form.nested.list.builder");
var FormModelMutatorNestedList = /** @class */ (function (_super) {
    tslib_1.__extends(FormModelMutatorNestedList, _super);
    function FormModelMutatorNestedList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormModelMutatorNestedList.prototype.init = function (options) {
        if (options == null) {
            return;
        }
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { options: JSON.parse(JSON.stringify(options)) }));
    };
    Object.defineProperty(FormModelMutatorNestedList.prototype, "builder", {
        get: function () {
            var stateValue = this.field.stateValue;
            if (stateValue != null && stateValue.options != null) {
                return new form_nested_list_builder_1.FormModelFieldNestedListBuilder(JSON.parse(JSON.stringify(stateValue.options)));
            }
            return new form_nested_list_builder_1.FormModelFieldNestedListBuilder();
        },
        enumerable: false,
        configurable: true
    });
    FormModelMutatorNestedList.prototype.clear = function () {
        this.init({ title: '', values: [] });
    };
    return FormModelMutatorNestedList;
}(form_field_1.FormModelMutatorField));
exports.FormModelMutatorNestedList = FormModelMutatorNestedList;
var FormModelFieldNestedList = /** @class */ (function (_super) {
    tslib_1.__extends(FormModelFieldNestedList, _super);
    function FormModelFieldNestedList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormModelFieldNestedList.isNestedList = function (field) {
        return field.type === core_api_1.IkeFieldType.NESTED_LIST;
    };
    Object.defineProperty(FormModelFieldNestedList.prototype, "Mutator", {
        get: function () {
            if (this._NLMutator == null) {
                this._NLMutator = new FormModelMutatorNestedList(this);
            }
            return this._NLMutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldNestedList.prototype, "options", {
        get: function () {
            return this.stateValue.options || { title: '', values: [] };
        },
        enumerable: false,
        configurable: true
    });
    FormModelFieldNestedList.prototype.findOptions = function (selections) {
        return FormModelFieldNestedList.findNestedListSelections(this.options, selections);
    };
    FormModelFieldNestedList.findNestedListSelections = function (options, selections) {
        if (!Array.isArray(selections) || selections.length === 0 || selections[0] == null) {
            return [];
        }
        var searchItem = String(selections[0]);
        if (options == null) {
            return [];
        }
        var option = options.values.find(function (_a) {
            var value = _a.value;
            return String(value) === searchItem;
        });
        if (option == null) {
            return [];
        }
        var values = [option];
        if (option.options == null) {
            return values;
        }
        var nextOption = this.findNestedListSelections(option.options, selections.slice(1));
        if (nextOption.length === 0) {
            return [];
        }
        return values.concat(nextOption);
    };
    FormModelFieldNestedList.prototype.getField = function () {
        return this;
    };
    return FormModelFieldNestedList;
}(form_field_1.FormModelField));
exports.FormModelFieldNestedList = FormModelFieldNestedList;
//# sourceMappingURL=form.nested.list.js.map